// Warms the Kjuup.io Abo embed so opening it from the cockpit is instant.
// Its HTML lists hashed assets, so they are read from the document itself.
const PAGE_URL = "/company-admin-app/kjuup-io.html";

let started = false;

function prefetch(href) {
  if (document.querySelector(`link[rel="prefetch"][href="${href}"]`)) return;
  const link = document.createElement("link");
  link.rel = "prefetch";
  link.href = href;
  link.crossOrigin = "anonymous";
  document.head.appendChild(link);
}

export default function prefetchKjuupIoApp() {
  if (started || typeof document === "undefined") return;
  started = true;
  fetch(PAGE_URL, { credentials: "same-origin" })
    .then((res) => (res.ok ? res.text() : ""))
    .then((html) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, "text/html");
      doc
        .querySelectorAll('link[rel="stylesheet"], link[rel="modulepreload"], script[src]')
        .forEach((node) => {
          const href = node.getAttribute("href") || node.getAttribute("src");
          if (href && href.startsWith("/company-admin-app/")) prefetch(href);
        });
    })
    .catch(() => {});
}
